/**
 * @generated SignedSource<<81a89bb46af549cc64b79085c05bcc05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicHeaderTopic$data = {
  readonly description: {
    readonly html: string | null;
  } | null;
  readonly images: ReadonlyArray<{
    readonly breakout: {
      readonly url: string | null;
    } | null;
    readonly breakoutSponsor: {
      readonly url: string | null;
    } | null;
    readonly icon: {
      readonly url: string | null;
    } | null;
    readonly type: string | null;
  } | null> | null;
  readonly name: string;
  readonly sponsor: {
    readonly " $fragmentSpreads": FragmentRefs<"sponsorTagSponsor">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"entityFollowButtonBase" | "topicHeaderRelatedLinksTopic">;
  readonly " $fragmentType": "topicHeaderTopic";
};
export type topicHeaderTopic$key = {
  readonly " $data"?: topicHeaderTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicHeaderTopic">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicHeaderTopic",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "topicHeaderRelatedLinksTopic"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityFollowButtonBase"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "description",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "html",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "type": {
              "values": [
                "MOBILE_APP_IMAGE",
                "BREAKOUT",
                "BREAKOUT_SPONSOR"
              ]
            }
          }
        }
      ],
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": "icon",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "118x118"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": "style(filter:{\"style\":\"118x118\"})"
        },
        {
          "alias": "breakout",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "2000x792"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": "style(filter:{\"style\":\"2000x792\"})"
        },
        {
          "alias": "breakoutSponsor",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "1560x218"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": "style(filter:{\"style\":\"1560x218\"})"
        }
      ],
      "storageKey": "images(filter:{\"type\":{\"values\":[\"MOBILE_APP_IMAGE\",\"BREAKOUT\",\"BREAKOUT_SPONSOR\"]}})"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Sponsor",
      "kind": "LinkedField",
      "name": "sponsor",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "sponsorTagSponsor"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Topic",
  "abstractKey": null
};
})();

(node as any).hash = "a54c7aaa318159f1078bf8dbf96c9ceb";

export default node;
